'use strict'

import InputMask from 'inputmask' // https://robinherbots.github.io/Inputmask/#/documentation

// UK inward code is always the last 3 chars (digit + 2 letters), so insert the space before them
const normalizeZipCode = (value) => {
    const v = String(value).toUpperCase().replace(/\s+/g, '')
    return v.length > 3 ? `${v.slice(0, -3)} ${v.slice(-3)}` : v
}

export default {
    oneNumber: InputMask({ regex: '^[0-9]{1}$', placeholder: '' }),
    onlyNumbers: InputMask({ regex: '^\\d+(\\.\\d{1,2})?$', placeholder: '' }),
    pinCode: InputMask({ regex: '^[0-9]{4,6}$' }),
    cellPhoneNumber: InputMask('07999 999 999'),
    employerPhoneNumber: InputMask({
        mask: ['0999 99 99', '0999 999 999', '09999 999 999'],
        placeholder: '',
    }),
    zipCode: InputMask({ regex: '^[a-zA-Z]{1,2}\\d[a-zA-Z\\d]?\\s?\\d[a-zA-Z]{2}$', casing: 'upper', onBeforeMask: normalizeZipCode }), // ['E1 6AN', 'W1A 1AA', 'E1W 3DA', 'DN16 9AA', 'CR22 6XH', 'SW1A 1AA']

    income: InputMask('currency', {
        inputType: 'text',
        placeholder: '___',
        groupSeparator: ' ',
        autoUnmask: true, // Automatically unmask the value when retrieved - $(input).val()
        autoGroup: true,
        rightAlign: false,
        digitsOptional: false,
        allowMinus: false,
        digits: 0,
        max: 999999,
    }),

    costs: InputMask('currency', {
        inputType: 'text',
        placeholder: '___',
        groupSeparator: ' ',
        autoUnmask: true, // Automatically unmask the value when retrieved - $(input).val()
        autoGroup: true,
        rightAlign: false,
        digitsOptional: false,
        allowMinus: false,
        digits: 0,
        max: 999999,
    }),

    bankAccountNumber: InputMask({ regex: '^[0-9]{8}$' }),
    bankSortCode: InputMask({
        regex: '^[0-9]{2}-[0-9]{2}-[0-9]{2}$',
        autoUnmask: true,
        removeMaskOnSubmit: true,
        postValidation: function () {
            const val = this.inputmask.unmaskedvalue()
            return !['000000', '999999'].includes(val)
        },
    }),

    sixDigitCode: InputMask({ regex: '^[0-9]{6}$', placeholder: '______' }),
}
